module.exports = __webpack_public_path__ + "img/slide-dog4.7234de61.png";